import HFConfig from "@/views/configs/hf/index.vue";

export default [
  {
    path: "hf",
    name: "H.F",
    component: HFConfig,
  },
];
